export class PershingExportOption {
    pdfCurrentPage: boolean;
    pdfAllPage: boolean;
    excelCurrentPage: boolean;
    excelAllPage: boolean;
    useMinWidth: boolean;
}

export class PershingExportEvent {
    exportFormat: string;
    exportColumns: any;
    exportFilterOptions: Array<any>;
    exportDataSet: string;
}
